var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report-ring-chart"},[_c('div',{staticClass:"report-ring-chart-wrapper"},[_c('div',{staticClass:"report-ring-chart-inner"},[_c('e-chart',{ref:"chart"})],1)]),_vm._v(" "),_c('div',{staticClass:"report-ring-chart-title"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8fb5232a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReportChart/ReportRingChart.vue
// module id = null
// module chunks = 